import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// import useApi from "../../Hooks/useApi";
// import * as postapi from "../../api/postapi";
import axios from "axios";

const PlatformCommisionModal = ({ show, setModalShow, selectedData, mode, refreshData }) => {
  const [data, setData] = useState({
    category: { label: "", value: "" },
    capAmount: "",
    comm_type_for_amount_lt_cap: "",
    comm_value_for_amount_lt_cap: "",
    comm_type_for_amount_gte_cap: "",
    comm_value_for_amount_gte_cap: "",
  });

  const [validate, setValidate] = useState(false)

  // const AddCommission = useApi(postapi.AddCommision);
  // const EditPlatformCommission = useApi(postapi.EditPaltformCommision);

  const categoryOptions = [
    { label: "Laptop", value: "1" },
    { label: "Mobiles", value: "2" },
    { label: "Tablets", value: "3" },
    { label: "TV/Monitors", value: "4" },
    { label: "Desktops", value: "5" },
    { label: "Accessories", value: "6" },
  ];
  const [error, setError] = useState("")

  const commTypeOptions = [
    { label: "Fixed", value: "fixed" },
    { label: "Percentage", value: "percent" },
  ];

  const handleChange = (key, value) => {
    setData((prev) => ({ ...prev, [key]: value }));
  };

  const handleCategoryChange = (selectedValue) => {
    const selectedCategory = categoryOptions.find((cat) => cat.value === selectedValue) || { label: "", value: "" };
    setData((prev) => ({ ...prev, category: selectedCategory }));
  };


  useEffect(() => {
    if (mode === "Edit" && selectedData) {
      setData({
        category: selectedData?.category ? { label: selectedData?.category, value: selectedData?.category_id } : { label: "", value: "" },
        capAmount: selectedData?.cap_amount || "",
        comm_type_for_amount_lt_cap: selectedData?.comm_type_for_amount_lt_cap || "",
        comm_value_for_amount_lt_cap: selectedData?.comm_value_for_amount_lt_cap || "",
        comm_type_for_amount_gte_cap: selectedData?.comm_type_for_amount_gte_cap || "",
        comm_value_for_amount_gte_cap: selectedData?.comm_value_for_amount_gte_cap || "",
      });
    } else {
      setData({
        category: { label: "", value: "" },
        capAmount: null,
        comm_type_for_amount_lt_cap: "",
        comm_value_for_amount_lt_cap: null,
        comm_type_for_amount_gte_cap: "",
        comm_value_for_amount_gte_cap: null,
      });
    }
  }, [mode, selectedData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidate(true);
    setError('')

    // Validate percentage values
    if (
      (data.comm_type_for_amount_lt_cap === "percent" &&
        +data.comm_value_for_amount_lt_cap > 99) ||
      (data.comm_type_for_amount_gte_cap === "percent" &&
        +data.comm_value_for_amount_gte_cap > 99)
    ) {
      setError("Percentage values should be between 0 and 99.");
      return// Prevent API call if validation fails
    } else if (data.comm_value_for_amount_gte_cap >= data.capAmount) {
      setError("Commission value for amount greater than or equal to cap amount should be less than the cap amount.");
      return// Prevent API call if validation fails
    } else if (data.comm_value_for_amount_lt_cap >= data.capAmount) {
      setError("Commission value for amount less than cap amount should be less than the cap amount.");
      return
    }

    const payload = {
      category: data.category.label,
      category_id: +data.category.value,
      cap_amount: +data.capAmount,
      comm_type_for_amount_lt_cap: data.comm_type_for_amount_lt_cap,
      comm_value_for_amount_lt_cap: +data.comm_value_for_amount_lt_cap,
      comm_type_for_amount_gte_cap: data.comm_type_for_amount_gte_cap,
      comm_value_for_amount_gte_cap: +data.comm_value_for_amount_gte_cap,
    };

    try {
      let res;
      if (mode === "Edit") {
        res = await axios.put(`${process.env.REACT_APP_API_URL}/platform-commission/${selectedData.id}`, payload, { withCredentials: true });

      } else if (mode === "Add") {
        res = await axios.post(`${process.env.REACT_APP_API_URL}/platform-commission/add`, payload, { withCredentials: true });
      }


      if (res) {
        setModalShow(false);
        setValidate(false);
        refreshData();
        setError("");
      }
    } catch (err) {
      console.log(err.response.data.error);

      setError(err.response.data.error);
      // console.error("Error submitting commission data:", err);
    }
  };




  return (
    <Modal show={show} onHide={() => {
      setData(setData({
        category: { label: "", value: "" },
        capAmount: null,
        comm_type_for_amount_lt_cap: "",
        comm_value_for_amount_lt_cap: null,
        comm_type_for_amount_gte_cap: "",
        comm_value_for_amount_gte_cap: null,
      })); setValidate(false); setModalShow(false); setError('')
    }
    } centered size="lg" >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "20px" }}>{mode === "Edit" ? "Edit" : "Add"} Platform Commission</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        <Form onSubmit={handleSubmit} validated={validate}>
          <Row className="gy-2 gx-3">
            {[
              <div className="my-2">
                <Form.Label>Select Catrgory<span className="text-danger">*</span></Form.Label>
                <Form.Select
                  required
                  // size="sm"
                  value={data?.category?.value}
                  onChange={(e) => handleCategoryChange(e.target.value)}
                  disabled={mode === 'Edit'}
                >
                  <option value="">Select Category</option>
                  {categoryOptions.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Please select a category.
                </Form.Control.Feedback>
              </div>
              ,
              <div className="my-2">
                <Form.Label>Enter Cap Amount<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="number"
                  required
                  placeholder="eg. 10"
                  value={data?.capAmount ? data?.capAmount : ''}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                    if (value.length > 7) value = value.slice(0, 7); // Restrict to 7 digits
                    handleChange("capAmount", value ? parseFloat(value) : ""
                    );
                  }}
                  onInput={(e) => {
                    if (e.target.value > 9999999) e.target.value.trim(); // Restrict input dynamically
                    if (e.target.value < 1 && e.target.value !== "") e.target.value = e.target.value; // Prevent negatives and zero
                  }}
                  min={1}
                  max={9999999}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a cap amount.
                </Form.Control.Feedback>
              </div>,
              <div className="my-2">
                <Form.Label>Commission Type for Amount LT Cap Amount<span className="text-danger">*</span></Form.Label>

                <Form.Select
                  required
                  // size="sm"

                  value={data?.comm_type_for_amount_lt_cap}
                  onChange={(e) =>
                    handleChange("comm_type_for_amount_lt_cap", e.target.value)
                  }

                >
                  <option value="">Select Commission Type</option>
                  {commTypeOptions.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>

                  ))}
                </Form.Select>
              </div>

              ,
              <div className="my-2">
                <Form.Label>Commission Value for Amount LT Cap Amount<span className="text-danger">*</span></Form.Label>

                <Form.Control
                  type="number"
                  required
                  placeholder="eg. 10"
                  isInvalid={
                    validate && data.comm_type_for_amount_lt_cap === "percent"
                      ? +data.comm_value_for_amount_lt_cap > 100
                      : false
                  }

                  isValid={validate && +data.comm_type_for_amount_lt_cap > 0}
                  value={data?.comm_value_for_amount_lt_cap}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                    value = value.slice(0, 7); // Trim to 7 digits

                    handleChange(
                      "comm_value_for_amount_lt_cap",
                      value ? parseFloat(value) : ""
                    );
                  }}
                  min={validate && 1}
                // max={validate && data.comm_type_for_amount_gte_cap === "percent" ? 99 : undefined}
                />


                <Form.Control.Feedback type="invalid">
                  Please Enter a Valid Commission Value
                </Form.Control.Feedback>
              </div>,
              <div className="my-2">
                <Form.Label>Commission Type for Amount GTE Cap Amount<span className="text-danger">*</span></Form.Label>

                <Form.Select
                  // size="sm"
                  value={data?.comm_type_for_amount_gte_cap}
                  required
                  onChange={(e) =>
                    handleChange("comm_type_for_amount_gte_cap", e.target.value)
                  }
                >
                  <option value="">Select Commission Type</option>
                  {commTypeOptions.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Form.Select>
              </div>,
              <div className="my-2">
                <Form.Label>Commission Value for Amount GTE Cap Amount<span className="text-danger">*</span></Form.Label>

                <Form.Control
                  type="number"
                  required
                  placeholder="eg. 10"
                  isInvalid={
                    validate && data.comm_type_for_amount_gte_cap === "percent"
                      ? +data.comm_value_for_amount_gte_cap > 100
                      : false
                  }

                  value={data?.comm_value_for_amount_gte_cap}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                    value = value.slice(0, 7); // Trim to 7 digits

                    handleChange(
                      "comm_value_for_amount_gte_cap",
                      value ? parseFloat(value) : ""
                    );
                  }}

                  isValid={validate && +data.comm_value_for_amount_gte_cap > 0}
                  min={validate && 1}
                  max={validate && data.comm_type_for_amount_gte_cap === "percent" ? 99 : undefined}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter a Valid Commission Value
                </Form.Control.Feedback>
              </div>,
            ].map((field, index) => (
              <Col xs={12} lg={6} key={index}>
                {field}
              </Col>
            ))}
          </Row>
          {error && <p className="text-danger">{error}</p>}

          <div className="d-flex justify-content-center mt-3 ">
            <Button className='w-25' type="submit">Submit</Button>
          </div>

        </Form>
      </Modal.Body>
    </Modal >
  );
};

export default PlatformCommisionModal;
